<template>
  <div
    class="base-badge"
    :style="{ width: `${width}px` }"
    :class="`bg-${color}`">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    width: {
      type: [Number, String],
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.base-badge {
  padding: 4px;
  height: 20px;
  color: #FFFFFF;
  font-size: 10px;

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>